import { defineComponent } from "vue";
import { OptionalVueProp, VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { ModuleButtonData } from "../menuData";
import { FocusHandler } from "./focusHandler";
import ModuleButton from "./moduleButton";

export default /*#__PURE__*/ defineComponent(
{
    name: "menuModuleList",
    props:
    {
        selectedModuleID: OptionalVueProp(Number),
        moduleButtonDatas: VueProp<ModuleButtonData[]>(Array),
        focusHandler: VueProp<FocusHandler>()
    },
    emits:
    {
        selectModule: null as unknown as (moduleButtonData: ModuleButtonData) => boolean,
    },
    render()
    {
        return (
            <ul class={Classes.moduleList} role="tablist">
                {
                    this.moduleButtonDatas.map((moduleButtonData) =>
                        <li class={Classes.moduleListItem} role="none" key={moduleButtonData.moduleID}>
                            <ModuleButton
                                isSelected={this.selectedModuleID === moduleButtonData.moduleID}
                                moduleButtonData={moduleButtonData}
                                focusHandler={this.focusHandler}
                                onSelectModule={(moduleButtonData: ModuleButtonData) => { this.$emit("selectModule", moduleButtonData); }}
                            />
                        </li>
                    )
                }
            </ul>
        );
    }
});